export const IMPLANT_MEDICAL_CHECK = 'implant_medical_check'

export const CONFIRM_IMPLANT_MEDICAL_CHECK = 'confirm_implant_medical_check'

export const UPLOAD_CBCT = 'implant_upload_cbct'




// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-3dscan/task-name.js